import { ChevronLeft } from "lucide-react";
import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { verifyOtp } from "../../store/actions/authActions";
import { store } from "../../store/store";
import { IVerifyOtp } from "../../types/authTypes";
import { setLoader } from "../../store/slices/feature/loader/loaderSlice";

export default function OtpInput() {
  const [otp, setOtp] = useState("");
  return (
    <div>
      {
        <>
          <button
            className="flex"
            onClick={() => {
              localStorage.clear();
              return (window.location.href = "/");
            }}
          >
            <ChevronLeft /> back
          </button>
          <h1 className="text-2xl font-semibold ">Verify OTP</h1>
          <p className="m-0 mb-4 text-gray-500">
            Enter the otp sent to your mail
          </p>
          <div className="mt-6 mb-6 text-blue-500 text-center flex justify-center items-center">
            <OTPInput
              value={otp}
              containerStyle="inputStyle"
              onChange={setOtp}
              inputType="number"
              shouldAutoFocus
              numInputs={4}
              renderSeparator={<span className="mx-2"></span>}
              renderInput={(props) => <input {...props} />}
            />
          </div>
          <button
            // disabled={otp.length === 4}
            onClick={async () => {
              const payload: IVerifyOtp = {
                otp,
                token: localStorage.getItem("otp-token") ?? "",
              };
              setLoader(false);
              store.dispatch(verifyOtp(payload));
            }}
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-md py-2 px-4 w-full"
          >
            Verify OTP
          </button>
        </>
      }
    </div>
  );
}
